/* Pebble & Pot Co — global app layer. build v4 (wishlist card + policy). */
(function () {
  'use strict';
  var WISH_KEY = 'pp_wishlist_v1';
  var RV_KEY = 'pp_recently_v1';
  var FREE_SHIP = (window.PP_FREE_SHIP || 150) * 100; // cents, AUD. Merchant can set window.PP_FREE_SHIP.
  var CUR = '$';

  /* ---------------- storage helpers ---------------- */
  function read(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } }
  function write(key, val) { try { localStorage.setItem(key, JSON.stringify(val.slice(0, 50))); } catch (e) {} }
  function money(cents) {
    var n = (cents / 100);
    return CUR + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function inWish(handle) { return read(WISH_KEY).some(function (i) { return i.handle === handle; }); }
  function toggleWish(item) {
    var list = read(WISH_KEY);
    var idx = list.findIndex(function (i) { return i.handle === item.handle; });
    if (idx > -1) { list.splice(idx, 1); } else { list.unshift(item); }
    write(WISH_KEY, list);
    updateWishCount();
    document.dispatchEvent(new CustomEvent('pp:wishlist'));
    return idx === -1;
  }

  /* ---------------- nav highlight ---------------- */
  function highlightBundle() {
    document.querySelectorAll('.header__inline-menu a[href*="/pages/build-a-bundle"], .header__menu a[href*="/pages/build-a-bundle"]').forEach(function (a) {
      a.classList.add('pp-bundle-link');
    });
  }

  /* ---------------- header wishlist icon ---------------- */
  function injectWishHeader() {
    if (document.querySelector('.pp-wishlist-header')) { updateWishCount(); return; }
    var cart = document.querySelector('#cart-icon-bubble');
    var anchor = cart ? cart.closest('a, .header__icon, li') : null;
    var host = anchor ? anchor.parentNode : (document.querySelector('.header__icons') || null);
    if (!host) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'header__icon header__icon--wishlist pp-wishlist-header link focus-inset';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span class="pp-wishlist-count" data-pp-wishcount>0</span>';
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(a, anchor); }
    else { host.appendChild(a); }
    updateWishCount();
  }
  function updateWishCount() {
    var n = read(WISH_KEY).length;
    document.querySelectorAll('[data-pp-wishcount]').forEach(function (el) {
      el.textContent = n; el.classList.toggle('is-visible', n > 0);
    });
  }

  /* ---------------- product cards: heart + data ---------------- */
  function cardData(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var handle = link.getAttribute('href').split('/products/')[1];
    if (!handle) return null;
    handle = handle.split('?')[0].split('#')[0];
    var img = card.querySelector('img');
    var titleEl = card.querySelector('.card__heading, .full-unstyled-link, [class*="card-information"] a, h3 a, .card__heading a');
    var priceEl = card.querySelector('.price-item--sale, .price-item--regular, .price__regular .price-item, .price-item');
    return {
      handle: handle,
      url: '/products/' + handle,
      title: (titleEl ? titleEl.textContent : link.textContent || '').trim(),
      image: img ? (img.currentSrc || img.src || (img.getAttribute('srcset') || '').split(' ')[0]) : '',
      price: priceEl ? priceEl.textContent.trim() : ''
    };
  }
  function injectHearts() {
    var cards = document.querySelectorAll('.card-wrapper, li.grid__item .card, product-card');
    cards.forEach(function (card) {
      if (card.querySelector('.pp-card-heart')) return;
      var data = cardData(card);
      if (!data) return;
      var media = card.querySelector('.card__media, .card__inner, .media') || card;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pp-card-heart' + (inWish(data.handle) ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.2C.6 8.8 2 5.5 5.2 5.5c2 0 3.2 1.1 3.8 2.2.6-1.1 1.8-2.2 3.8-2.2 3.2 0 4.6 3.3 3.2 6.3C19.5 16.4 12 21 12 21z" transform="translate(0 -1)"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var added = toggleWish(data);
        btn.classList.toggle('is-active', added);
      });
      media.appendChild(btn);
    });
  }

  /* ---------------- recently viewed (product pages) ---------------- */
  function trackRecentlyViewed() {
    if (!/\/products\//.test(location.pathname)) return;
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    var prod = null;
    scripts.forEach(function (s) {
      if (prod) return;
      try { var j = JSON.parse(s.textContent); if (j && j['@type'] === 'Product') prod = j; } catch (e) {}
    });
    var handle = location.pathname.split('/products/')[1];
    if (handle) handle = handle.split('?')[0].split('#')[0];
    var item = {
      handle: handle,
      url: '/products/' + handle,
      title: prod ? prod.name : (document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : handle),
      image: prod && prod.image ? (Array.isArray(prod.image) ? prod.image[0] : prod.image) : (document.querySelector('meta[property="og:image"]') || {}).content || '',
      price: prod && prod.offers ? money(Math.round(parseFloat(prod.offers.price || prod.offers.lowPrice || 0) * 100)) : ''
    };
    if (!item.handle) return;
    var list = read(RV_KEY).filter(function (i) { return i.handle !== item.handle; });
    list.unshift(item);
    write(RV_KEY, list.slice(0, 12));
  }

  /* ---------------- render wishlist / recently pages ---------------- */
  function renderGrid(container, list, opts) {
    if (!container) return;
    if (!list.length) {
      container.innerHTML = '<div class="pp-empty-state"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 21s-7.5-4.6-10-9.2C.6 8.8 2 5.5 5.2 5.5c2 0 3.2 1.1 3.8 2.2.6-1.1 1.8-2.2 3.8-2.2 3.2 0 4.6 3.3 3.2 6.3C19.5 16.4 12 21 12 21z"/></svg><h2>' + opts.emptyTitle + '</h2><p>' + opts.emptyText + '</p><a class="pp-btn" href="/collections/all" style="margin-top:1rem;">Shop all products</a></div>';
      return;
    }
    var html = '<div class="pp-grid">' + list.map(function (i) {
      return '<div class="pp-pcard" data-handle="' + i.handle + '">' +
        (opts.removable ? '<button class="pp-pcard__x" data-remove="' + i.handle + '" aria-label="Remove">&times;</button>' : '') +
        '<a class="pp-pcard__media" href="' + i.url + '">' + (i.image ? '<img src="' + i.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="pp-pcard__body">' +
        '<a class="pp-pcard__title" href="' + i.url + '">' + i.title + '</a>' +
        (i.price ? '<span class="pp-pcard__price">' + i.price + '</span>' : '') +
        '<a class="pp-pcard__cta" href="' + i.url + '">View product</a>' +
        '</div></div>';
    }).join('') + '</div>';
    container.innerHTML = html;
  }
  function mountPages() {
    var w = document.querySelector('[data-pp-wishlist]');
    if (w) {
      var draw = function () { renderGrid(w, read(WISH_KEY), { removable: true, emptyTitle: 'Your wishlist is empty', emptyText: 'Tap the heart on any product to save it here.' }); };
      draw();
      w.addEventListener('click', function (e) {
        var r = e.target.closest('[data-remove]'); if (!r) return;
        var list = read(WISH_KEY).filter(function (i) { return i.handle !== r.getAttribute('data-remove'); });
        write(WISH_KEY, list); updateWishCount(); draw();
      });
      document.addEventListener('pp:wishlist', draw);
    }
    var r = document.querySelector('[data-pp-recently]');
    if (r) {
      var cur = /\/products\//.test(location.pathname) ? location.pathname.split('/products/')[1].split('?')[0] : '';
      var rl = read(RV_KEY).filter(function(i){ return i.handle !== cur; });
      var onProduct = document.body.classList.contains('pp-tmpl-product');
      if (!rl.length && onProduct) {
        var sec = r.closest('.shopify-section'); if (sec) sec.style.display = 'none';
      } else {
        renderGrid(r, rl, { removable: false, emptyTitle: 'Nothing here yet', emptyText: 'Products you view will appear here.' });
      }
    }
  }

  /* ---------------- cart free-shipping bar ---------------- */
  function shipBarHTML(total) {
    var remain = FREE_SHIP - total;
    var pct = Math.min(100, Math.round(total / FREE_SHIP * 100));
    var msg = remain <= 0
      ? '<span class="is-unlocked">🎉 You\'ve unlocked <strong>FREE shipping</strong></span>'
      : 'You\'re <strong>' + money(remain) + '</strong> away from <strong>FREE shipping</strong>';
    return '<p class="pp-ship-bar__msg' + (remain <= 0 ? ' is-unlocked' : '') + '">' + msg + '</p>' +
      '<div class="pp-ship-bar__track"><div class="pp-ship-bar__fill" style="width:' + pct + '%"></div></div>';
  }
  function syncShipBar(total) {
    var drawer = document.querySelector('.cart-drawer .drawer__inner') || document.querySelector('cart-drawer .drawer__inner');
    if (!drawer) return;
    var header = drawer.querySelector('.drawer__header');
    var bar = drawer.querySelector('.pp-ship-bar');
    if (total === 0) { if (bar) bar.remove(); return; }
    if (!bar) {
      bar = document.createElement('div'); bar.className = 'pp-ship-bar';
      if (header && header.parentNode) header.parentNode.insertBefore(bar, header.nextSibling);
      else drawer.insertBefore(bar, drawer.firstChild);
    }
    bar.innerHTML = shipBarHTML(total);
    // trust row near checkout
    var ctas = drawer.querySelector('.cart__ctas, .drawer__footer');
    if (ctas && !ctas.querySelector('.pp-cart-trust')) {
      var trust = document.createElement('div'); trust.className = 'pp-cart-trust';
      trust.innerHTML = '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>Secure checkout</span>' +
        '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>Australia-wide delivery</span>' +
        '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>Trade pricing available</span>';
      ctas.appendChild(trust);
    }
  }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { syncShipBar(c.total_price || 0); })
      .catch(function () {});
  }
  function watchCart() {
    refreshCart();
    // re-sync when the drawer DOM updates (theme re-renders on add/remove)
    var target = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
    if (target && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () { refreshCart(); });
      mo.observe(target, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble, [href="/cart"], .cart-notification__links')) setTimeout(refreshCart, 350);
    });
  }

  /* ---------------- predictive search popular keywords ---------------- */
  function injectSearchPopular() {
    var KW = (window.PP_POPULAR_SEARCHES || ['Pebbles', 'Fibreclay Pots', 'Feature Trees', 'Olive Trees', 'Planters', 'White Pebbles', 'Troughs']);
    var results = document.querySelector('predictive-search .predictive-search, #predictive-search');
    if (!results || results.querySelector('.pp-search-popular')) return;
    var div = document.createElement('div');
    div.className = 'pp-search-popular';
    div.innerHTML = '<p class="pp-search-popular__label">Popular searches</p><div class="pp-search-popular__tags">' +
      KW.map(function (k) { return '<a class="pp-search-popular__tag" href="/search?q=' + encodeURIComponent(k) + '">' + k + '</a>'; }).join('') + '</div>';
    results.insertBefore(div, results.firstChild);
  }

  /* ---------------- init + observe ---------------- */
  /* ---------------- cute, consistent header + menu icons ---------------- */
  var ICON = {
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M5 21c0-3.9 3.1-7 7-7s7 3.1 7 7"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l1 12H5L6 8z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    pebble: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><ellipse cx="9" cy="14.5" rx="5" ry="4"/><ellipse cx="16" cy="10" rx="4" ry="3.2"/></svg>',
    pot: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M5.5 9h13l-1.5 10h-10L5.5 9z"/><path d="M5 9h14"/><path d="M10 9c0-2 .5-4 2-4s2 2 2 4"/></svg>',
    tree: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 3l4 6h-2.5l3 5H14v4h-4v-4H7.5l3-5H8l4-6z"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><rect x="4" y="9" width="16" height="11" rx="1"/><path d="M3 9h18M12 9v11M12 9C10 9 8 8.5 8 6.8 8 5.5 9 5 9.8 5 11.5 5 12 9 12 9zM12 9c2 0 4-.5 4-2.2C16 5.5 15 5 14.2 5 12.5 5 12 9 12 9z"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z"/></svg>',
    mail: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 7l8.5 6 8.5-6"/></svg>'
  };
  function setIcon(el, svg) {
    if (!el) return;
    el.querySelectorAll('svg').forEach(function (s) { s.remove(); });
    el.insertAdjacentHTML('afterbegin', svg);
    el.classList.add('pp-iconized');
  }
  function refineHeaderIcons() {
    setIcon(document.querySelector('.header__icon--search'), ICON.search);
    setIcon(document.querySelector('.header__icon--account'), ICON.user);
    var cart = document.querySelector('#cart-icon-bubble');
    if (cart && !cart.classList.contains('pp-iconized')) setIcon(cart, ICON.bag);
  }
  function addMenuIcons() {
    var map = [
      { kw: 'pebble', i: ICON.pebble }, { kw: 'planter', i: ICON.pot }, { kw: 'pot', i: ICON.pot },
      { kw: 'tree', i: ICON.tree }, { kw: 'plant', i: ICON.tree }, { kw: 'bundle', i: ICON.gift },
      { kw: 'inspiration', i: ICON.spark }, { kw: 'contact', i: ICON.mail }
    ];
    var items = document.querySelectorAll('.header__inline-menu > ul > li > .header__menu-item, .header__inline-menu > ul > li > header-menu summary.header__menu-item');
    items.forEach(function (item) {
      if (item.querySelector('.pp-nav-ic')) return;
      var t = (item.textContent || '').toLowerCase();
      var f = null;
      for (var j = 0; j < map.length; j++) { if (t.indexOf(map[j].kw) > -1) { f = map[j]; break; } }
      if (!f) return;
      var span = item.querySelector('span') || item;
      span.insertAdjacentHTML('afterbegin', '<span class="pp-nav-ic" aria-hidden="true">' + f.i + '</span>');
    });
  }
  function run() {
    highlightBundle();
    injectWishHeader();
    injectHearts();
    mountPages();
  }
  function articleProgress() {
    if (!document.body.classList.contains('pp-tmpl-article')) return;
    var bar = document.createElement('div'); bar.className = 'pp-reading-progress';
    document.body.appendChild(bar);
    function upd() {
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.width = (max > 0 ? (h.scrollTop / max * 100) : 0) + '%';
    }
    window.addEventListener('scroll', upd, { passive: true }); upd();
  }
  function init() {
    trackRecentlyViewed();
    run();
    watchCart();
    articleProgress();
    // re-run on dynamic section reloads
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { highlightBundle(); injectHearts(); injectSearchPopular(); });
      mo.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('focusin', function (e) {
      if (e.target.closest('[type="search"], .search__input')) setTimeout(injectSearchPopular, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
